"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThirdPartyProviderSchema = exports.TeamsCredentialsSchema = void 0;
const yup_1 = require("yup");
const model_schema_1 = require("../base/model.schema");
exports.TeamsCredentialsSchema = (0, yup_1.object)({
    tenantId: (0, yup_1.string)().notRequired(),
    clientId: (0, yup_1.string)().notRequired(),
    scope: (0, yup_1.string)().notRequired(),
    clientSecret: (0, yup_1.string)().notRequired(),
    grantType: (0, yup_1.string)().notRequired(),
});
exports.ThirdPartyProviderSchema = model_schema_1.Schema.shape({
    teamsCredentials: exports.TeamsCredentialsSchema.notRequired(),
});
